export default class LogoGrid extends HTMLElement {
    constructor() {
        super();
    }
}

window.customElements.define('nc-logo-grid', LogoGrid);
